import { IconProps } from './IconProps';

export function ChevronUp(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.2998 15.7783L12 9.41406L5.7002 15.7783L5 15.0713L12 8L12.7002 8.70703L19 15.0713L18.2998 15.7783Z"
                fill="#66182A"
            />
        </svg>
    );
}
